import styled from 'styled-components';

export const Button = styled.button`
  background-color: black;
  color: white;
  min-width: 2.6rem;
  min-height: 2.6rem;
  max-width: 2.6rem;
  max-height: 2.6rem;
  border: none;
  border-radius: 99999rem;
  margin: 0 0.4rem 0 0;
`;